// extracted by mini-css-extract-plugin
module.exports = {"midBlue":"title_midBlue__1M3TF","night":"title_night__1pVwN","title":"title_title__3u9El"};